import { createSelector } from '@reduxjs/toolkit';
import { fetchStatuses } from '../../../constants/fetchStatuses';
import { ReducerState } from '../../store.types';

export const appConfigSelector = ({ appConfig }: ReducerState) => appConfig;
export const appConfigLoadingSelector = createSelector(
  appConfigSelector,
  ({ fetchStatus }) => fetchStatus === fetchStatuses.pending,
);
